







































import { Component, Prop, Vue } from 'vue-property-decorator';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';

@Component({
  name: 'AccessibleResourceItem',
  components: {
    'bc-entity-select': EntitySelect,
  },
})
export default class AccessibleResourceItem extends Vue {
  @Prop({ type: Object, required: true }) readonly value!: {
    resource_id: number | null;
    schedule_id?: number | null;
  };
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  get formModel() {
    return this.value;
  }

  set formModel(value) {
    this.$emit('input', value);
  }

  get subscriptionScheduleConfig() {
    return {
      label: 'centers.resources.access_control_schedule.label',
      rules: ['nullable'],
      inputType: 'entity-select',
      selectLabel: 'name',
      selectEntity: 'schedule',
      selectMultiple: false,
      selectClearable: true,
      filters: [
        {
          filterField: 'type',
          modelField: null,
          value: 'access_control',
        },
      ],
    };
  }

  get accessibleResourcesConfig() {
    return {
      label: 'global.subscription_category.subscription_category_accessible_resource_ids.label',
      selectLabel: 'name',
      selectMultiple: false,
      selectEntity: 'resource',
      defaultValue: [],
      filters: [
        {
          filterField: 'has_access_control',
          modelField: null,
          value: 1,
        },
      ],
      showHelp: true,
      help: 'global.subscription_category.subscription_category_accessible_resource_ids.help',
    };
  }

  clickOnDelete() {
    this.$emit('click-on-delete');
  }
}
